export const SET_PRODUCTS = 'setProducts'
export const FETCH_START = 'fetStartProducts'
export const FETCH_END = 'fetEndProducts'
export const SET_IMAGE_PRODUCT = 'setImageProduct'
export const FETCH_IMAGES_START = 'fetchImagesStart'
export const FETCH_IMAGES_END = 'fetchImagesEnd'